export const GUIDE_CATEGORY_LABELS = {
  homepage: "홈페이지",
  hospital: "병원",
  industry: "병원",
  platform: "웹·CMS",
  ai: "AI·자동화",
  saas: "SaaS",
  search: "SEO·AEO·GEO",
};

export function guideCategoryLabel(category, hubCategories = []) {
  const fromHub = (hubCategories || []).find((row) => row.id === category);
  if (fromHub?.label) return fromHub.label;
  return GUIDE_CATEGORY_LABELS[category] || category || "가이드";
}

export function slugifyHeading(text) {
  return String(text || "")
    .trim()
    .toLowerCase()
    .replace(/·/g, "-")
    .replace(/[^a-z0-9가-힣]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80) || "section";
}

export function guideHeadings(blocks = []) {
  return (blocks || [])
    .filter((block) => block.type === "h2" && block.text)
    .map((block) => ({ id: slugifyHeading(block.text), text: block.text }));
}

export function splitRelated(related = []) {
  const groups = { service: [], guide: [], portfolio: [], other: [] };
  (related || []).forEach((link) => {
    const href = link.href || "";
    const kind = link.kind || (href.startsWith("/services") ? "service" : href.startsWith("/guides") ? "guide" : href.startsWith("/portfolio") ? "portfolio" : "other");
    (groups[kind] || groups.other).push(link);
  });
  return groups;
}
